module.exports = __webpack_public_path__ + "static/img/step2.80d69317.png";